import * as React from 'react';
import { useClientSettings } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/ClientSettingsContext';

interface Props {
    reservationId: string;
}

export const PrintBookingConfirmationToolButton: React.FC<Props> = ({ reservationId }) => {
    const { supportsPrintBookingConfirmation } = useClientSettings();

    if (!supportsPrintBookingConfirmation) return null;

    return (
        <button
            className="btn btn-outline-contrast"
            onClick={() => window.open(`/booking-confirmation/${reservationId}`, '_blank')}
        >
            <i className="fa-solid fa-file-pdf me-1"></i>
            Print Booking Confirmation
        </button>
    );
};
